<template>
    <v-container>
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <v-row class="mt-10">
            <v-col>
                <span class="header bold text-tcdc-green">CONSULT</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ServiceExpandable from "../../components/expandables/ServiceExpandable";
    import { mapState } from 'vuex';

    export default {
        async created() {
            this.items[0].text = this.branchName;
            let path, path_a;
            for (const b of this.allBranches) {
                if (this.branchId === b.branch_id) {
                    if (this.branchId === 0) {
                        path = `/home`;
                        path_a = `/service`;
                        break;
                    }
                    path = `/home/${b.tag_name}`;
                    path_a = `/service/${b.tag_name}`;
                    break;
                }
            }
            this.items[0].to = path;
            this.items[1].to = path_a;
            if (this.$route.params.branch) {
                let params = { branch_id: 0, lang: this.lang };
                for (const b of this.allBranches) {
                    if (this.$route.params.branch === b.tag_name) {
                        if (!this.$route.params.branch) {
                            await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                            break;
                        }
                        params.branch_id = b.branch_id;
                        if (this.$route.params.branch === 'mini-tcdc') {
                            await this.$store.dispatch('Branch/getMiniByBranch', params);
                            break;
                        }
                        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                        await this.$store.dispatch("Branch/getBranchById", params.branch_id);
                        break;
                    }
                }
            } else {
                if (this.branchId !== 0) {
                    let params = { branch_id: 0, lang: this.lang };
                    await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                    await this.$store.dispatch("Branch/getBranchById", params.branch_id);
                }
            }
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                allBranches: state => state.Branch.branches,
                lang: state => state.Branch.lang,
                branchId: state => state.Branch.branch_id
            }),
            branchChanged: function () {
                return this.branchName;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
                let path, path_a;
                for (const b of this.allBranches) {
                    if (this.branchId === b.branch_id) {
                        if (this.branchId === 0) {
                            path = `/home`;
                            path_a = `/service`;
                            break;
                        }
                        path = `/home/${b.tag_name}`;
                        path_a = `/service/${b.tag_name}`;
                        break;
                    }
                }
                this.items[0].to = path;
                this.items[1].to = path_a;
            }
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    // disabled: true,
                    // href: "breadcrumbs_dashboard",
                    to: "/home/tcdc-bangkok"
                },
                {
                    text: "SERVICE",
                    to: "/service"
                },
                {
                    text: "CONSULT",
                    disabled: true,
                    // href: "breadcrumbs_link_1",
                }
            ]
        }),
        components: {
        }
    };
</script>

<style></style>
